"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
class Uploader extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Function to upload image
     * @param {FormData} file
     * @param {string} fileName
     * @returns
     */
    async uploadImage(file, fileName) {
        try {
            const data = await this._apiV2.uploadAPI.uploadImage(file, fileName);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = Uploader;
